var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRepository = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.21 1.25c.313 0 .615.109.855.306l.1.09.09.1c.196.24.305.542.305.855v10.813a1.352 1.352 0 0 1-1.35 1.352H4.702a2.255 2.255 0 0 1-2.241-2.03l-.012-.222V3.502A2.254 2.254 0 0 1 4.702 1.25h7.508zM4.702 11.762a.753.753 0 0 0-.752.752l.015.147a.754.754 0 0 0 .737.605h7.358v-1.504H4.702zm0-9.012a.753.753 0 0 0-.752.752v6.89c.24-.084.494-.13.752-.13h7.358V2.75h-1.152v4.056a.501.501 0 0 1-.853.353l-1.45-1.448-1.448 1.448a.5.5 0 0 1-.853-.353V2.75H4.702zm2.602 2.849l.948-.949.079-.064a.501.501 0 0 1 .629.064l.948.949V2.75H7.304v2.849z",
  fill: "#071722",
  fillOpacity: 0.84
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRepository);
export default ForwardRef;